import * as React from "react";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    arrowLeft,
    arrowarrow,
    arrowarrows,
    filtre,
    keyuser,
    deleted,
    notification,
    arrowSeek,
    red,
    Delected,
    explorer,
    delected,
    arrowRight,
    calandar,
    userAdd,
    supervision,
    dbArrowLeft,
    arrowWite,
    dbArrowRight,
    arrow,
    user,
    color,
  } = props;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @name lodash
   * @name i18next
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */
  return (
    <div className="arrowDatePicker">
      {arrowRight && (
        <svg width="100%" height="100%" viewBox="0 0 64 64" version="1.1">
          <path d="M42,56l-20,-23.988l20,-24.012" fill="#808fa3" />
        </svg>
      )}
      {arrowLeft && (
        <svg width="100%" height="100%" viewBox="0 0 64 64" version="1.1">
          <path d="M22,8l20,23.988l-20,24.012" fill="#808fa3" />
        </svg>
      )}
      {dbArrowRight && (
        <svg width="100%" height="100%" viewBox="0 0 64 64" version="1.1">
          <path d="M32,56l-20,-23.988l20,-24.012" fill="#808fa3" />
        </svg>
      )}
      {dbArrowLeft && (
        <svg width="100%" height="100%" viewBox="0 0 64 64" version="1.1">
          <path d="M32,8l20,23.988l-20,24.012" fill="#808fa3" />
        </svg>
      )}
      {calandar && (
        <svg x="0px" y="0px" viewBox="0 0 58 58" version="1.1">
          <path
            d="M42.899,4.5c-0.465-2.279-2.484-4-4.899-4c-0.553,0-1,0.447-1,1s0.447,1,1,1c1.654,0,3,1.346,3,3s-1.346,3-3,3
                    c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.414,0,4.434-1.721,4.899-4H56v9H2v-9h14h3c0.553,0,1-0.447,1-1s-0.447-1-1-1h-1.816
                    c0.414-1.162,1.514-2,2.816-2c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5
                    s-2.243-5-5-5c-2.414,0-4.434,1.721-4.899,4H0v13v40h58v-40v-13H42.899z M56,55.5H2v-38h54V55.5z"
          />
          <path
            d="M26,2.5c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5s-2.243-5-5-5
                    c-0.553,0-1,0.447-1,1S25.447,2.5,26,2.5z"
          />
          <path
            d="M32,2.5c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5s-2.243-5-5-5
                    c-0.553,0-1,0.447-1,1S31.447,2.5,32,2.5z"
          />
          <circle cx="22" cy="24.5" r="1" />
          <circle cx="29" cy="24.5" r="1" />
          <circle cx="36" cy="24.5" r="1" />
          <circle cx="43" cy="24.5" r="1" />
          <circle cx="50" cy="24.5" r="1" />
          <circle cx="8" cy="32.5" r="1" />
          <circle cx="15" cy="32.5" r="1" />
          <circle cx="22" cy="32.5" r="1" />
          <circle cx="29" cy="32.5" r="1" />
          <circle cx="36" cy="32.5" r="1" />
          <circle cx="43" cy="32.5" r="1" />
          <circle cx="50" cy="32.5" r="1" />
          <circle cx="8" cy="39.5" r="1" />
          <circle cx="15" cy="39.5" r="1" />
          <circle cx="22" cy="39.5" r="1" />
          <circle cx="29" cy="39.5" r="1" />
          <circle cx="36" cy="39.5" r="1" />
          <circle cx="43" cy="39.5" r="1" />
          <circle cx="50" cy="39.5" r="1" />
          <circle cx="8" cy="47.5" r="1" />
          <circle cx="15" cy="47.5" r="1" />
          <circle cx="22" cy="47.5" r="1" />
          <circle cx="29" cy="47.5" r="1" />
          <circle cx="36" cy="47.5" r="1" />
        </svg>
      )}
      {arrow && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 560 795"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M419.18 668.773V404H353.384V668.773L264.667 580.076L218 626.732L386.2 794.895L559.511 621.786L512.844 575.13L419.18 668.773Z"
            fill="#808fa3"
          />
          <path
            d="M136.868 126.122V404.084H202.829V126.122L296.493 219.765L343.16 173.108L169.849 0L0 169.811L46.6672 216.468L136.868 126.122Z"
            fill="#808fa3"
          />
        </svg>
      )}
      {arrowarrow && (
        <svg viewBox="0 0 24 24" width="13px" height="13px">
          <path
            fill="#808fa3"
            d="M23.37 5.62a2.15 2.15 0 0 0-3 0L12 13.87 3.68 5.62a2.2 2.2 0 0 0-3.05 0 2.1 2.1 0 0 0 0 3l9.86 9.76a2.14 2.14 0 0 0 3 0l9.86-9.76a2.1 2.1 0 0 0 .02-3z"
          />
        </svg>
      )}
      {arrowarrows && (
        <svg viewBox="0 0 24 24" width="7px" height="7px">
          <path
            fill="#808fa3"
            d="M23.37 5.62a2.15 2.15 0 0 0-3 0L12 13.87 3.68 5.62a2.2 2.2 0 0 0-3.05 0 2.1 2.1 0 0 0 0 3l9.86 9.76a2.14 2.14 0 0 0 3 0l9.86-9.76a2.1 2.1 0 0 0 .02-3z"
          />
        </svg>
      )}
      {deleted && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 434 549"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M396.518 64.6442H323.216V17.011C323.216 7.42313 315.482 0 305.895 0C304.965 0 304.344 0.310568 304.042 0.620426C303.731 0.310568 303.111 0 302.801 0H130.523H129.289H128.048C118.461 0 111.038 7.42313 111.038 17.011V64.6449H37.4262C16.3906 64.6449 0 81.0355 0 102.071V129.29V163.311H32.477V511.884C32.477 532.921 48.5578 549.001 69.5934 549.001H364.351C385.387 549.001 401.777 532.921 401.777 511.884V163.311H433.944V129.29V102.071C433.944 81.0355 417.547 64.6442 396.518 64.6442ZM145.059 34.0213H288.885V64.6442H145.059V34.0213ZM367.446 511.885C367.446 514.055 366.515 514.979 364.351 514.979H69.5934C67.4294 514.979 66.4991 514.055 66.4991 511.885V163.31H367.446V511.885ZM399.613 129.289H34.3312V102.07C34.3312 99.9056 35.2615 98.6655 37.4255 98.6655H396.518C398.682 98.6655 399.613 99.9056 399.613 102.07V129.289Z"
            fill={color}
          />
          <path
            d="M313.628 203.211H279.297V484.667H313.628V203.211Z"
            fill={color}
          />
          <path
            d="M234.447 203.211H200.116V484.667H234.447V203.211Z"
            fill={color}
          />
          <path
            d="M155.266 203.211H120.935V484.667H155.266V203.211Z"
            fill={color}
          />
        </svg>
      )}
      {Delected && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 434 549"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M396.518 64.6442H323.216V17.011C323.216 7.42313 315.482 0 305.895 0C304.965 0 304.344 0.310568 304.042 0.620426C303.731 0.310568 303.111 0 302.801 0H130.523H129.289H128.048C118.461 0 111.038 7.42313 111.038 17.011V64.6449H37.4262C16.3906 64.6449 0 81.0355 0 102.071V129.29V163.311H32.477V511.884C32.477 532.921 48.5578 549.001 69.5934 549.001H364.351C385.387 549.001 401.777 532.921 401.777 511.884V163.311H433.944V129.29V102.071C433.944 81.0355 417.547 64.6442 396.518 64.6442ZM145.059 34.0213H288.885V64.6442H145.059V34.0213ZM367.446 511.885C367.446 514.055 366.515 514.979 364.351 514.979H69.5934C67.4294 514.979 66.4991 514.055 66.4991 511.885V163.31H367.446V511.885ZM399.613 129.289H34.3312V102.07C34.3312 99.9056 35.2615 98.6655 37.4255 98.6655H396.518C398.682 98.6655 399.613 99.9056 399.613 102.07V129.289Z"
            fill={color}
          />
          <path
            d="M313.628 203.211H279.297V484.667H313.628V203.211Z"
            fill={color}
          />
          <path
            d="M234.447 203.211H200.116V484.667H234.447V203.211Z"
            fill={color}
          />
          <path
            d="M155.266 203.211H120.935V484.667H155.266V203.211Z"
            fill={color}
          />
        </svg>
      )}
      {filtre && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={color}
            d="M37.213 29c0 0.373-0.293 0.667-0.667 0.667h-15.947c-0.227 1.253-1.307 2.213-2.613 2.213s-2.4-0.96-2.613-2.213h-12.373c-0.373 0-0.667-0.293-0.667-0.667s0.293-0.667 0.667-0.667h12.453c0.36-1.053 1.347-1.827 2.52-1.827s2.16 0.773 2.52 1.827h16.053c0.373 0 0.667 0.293 0.667 0.667zM36.547 19.147h-6.667c-0.36-1.053-1.347-1.827-2.52-1.827s-2.16 0.773-2.52 1.827h-21.84c-0.373 0-0.667 0.293-0.667 0.667s0.293 0.667 0.667 0.667h21.747c0.227 1.253 1.307 2.213 2.613 2.213s2.4-0.96 2.613-2.213h6.56c0.373 0 0.667-0.293 0.667-0.667s-0.28-0.667-0.653-0.667zM3 10.987h5.307c0.227 1.267 1.32 2.213 2.627 2.213s2.4-0.96 2.613-2.213h23c0.373 0 0.667-0.293 0.667-0.667s-0.293-0.667-0.667-0.667h-23.107c-0.347-1.053-1.333-1.827-2.507-1.827s-2.16 0.773-2.52 1.827h-5.413c-0.373 0-0.667 0.293-0.667 0.667s0.307 0.667 0.667 0.667z"
          />
        </svg>
      )}
      {delected && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 498 498"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M292.575 249L488.662 52.9125C501.112 40.4625 501.112 20.75 488.662 9.3375C476.212 -3.1125 456.5 -3.1125 445.088 9.3375L249 204.388L52.9125 9.3375C40.4625 -3.1125 20.75 -3.1125 9.3375 9.3375C-3.1125 21.7875 -3.1125 41.5 9.3375 52.9125L204.388 249L9.3375 444.05C-3.1125 456.5 -3.1125 476.212 9.3375 487.625C15.5625 494.888 22.825 498 31.125 498C39.425 498 46.6875 494.887 52.9125 488.662L249 292.575L445.088 488.662C451.313 494.887 459.612 498 466.875 498C474.138 498 482.437 494.887 488.662 488.662C501.112 476.212 501.112 456.5 488.662 445.088L292.575 249Z"
            fill={color}
          />
        </svg>
      )}
      {arrowWite && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 727 536"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M377.673 529.084L723.387 27.6645C726.844 22.4774 728.573 15.5613 725.116 8.64516C721.658 3.45806 716.473 -4.60163e-07 709.558 -7.62396e-07L18.1298 -3.09857e-05C11.2155 -3.12879e-05 6.02977 3.45803 2.57263 8.64513C0.844057 12.1032 0.844083 13.8322 0.844083 17.2903C0.844083 20.7484 2.57267 24.2064 4.30124 27.6645L350.016 529.084C353.473 534.271 358.658 536 363.844 536C369.03 536 374.215 532.542 377.673 529.084Z"
            fill="white"
          />
        </svg>
      )}
      {arrowSeek && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 727 536"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M377.673 529.084L723.387 27.6645C726.844 22.4774 728.573 15.5613 725.116 8.64516C721.658 3.45806 716.473 -4.60163e-07 709.558 -7.62396e-07L18.1298 -3.09857e-05C11.2155 -3.12879e-05 6.02977 3.45803 2.57263 8.64513C0.844057 12.1032 0.844083 13.8322 0.844083 17.2903C0.844083 20.7484 2.57267 24.2064 4.30124 27.6645L350.016 529.084C353.473 534.271 358.658 536 363.844 536C369.03 536 374.215 532.542 377.673 529.084Z"
            fill={color}
          />
        </svg>
      )}
      {user && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 564 537"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M280.79 301.144C364.056 301.144 431.593 233.606 431.593 150.341C431.593 67.076 364.055 0 280.79 0C197.525 0 129.987 67.538 129.987 150.341C129.987 233.144 197.524 301.144 280.79 301.144Z"
            fill={color}
          />
          <path
            d="M19.891 536.6H543.539C554.641 536.6 563.43 527.811 563.43 516.709C563.43 412.627 478.777 327.511 374.232 327.511H189.198C85.116 327.511 0 412.164 0 516.709C0 527.811 8.789 536.6 19.891 536.6Z"
            fill={color}
          />
        </svg>
      )}
      {userAdd && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 492 492"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M465.167 211.614H280.245V26.691C280.245 18.267 268.806 0.000976562 245.929 0.000976562C223.052 0.000976562 211.613 18.268 211.613 26.691V211.615H26.69C18.267 211.614 0 223.053 0 245.929C0 268.805 18.267 280.245 26.69 280.245H211.614V465.169C211.614 473.591 223.052 491.859 245.93 491.859C268.808 491.859 280.246 473.591 280.246 465.169V280.245H465.17C473.592 280.245 491.86 268.807 491.86 245.929C491.86 223.051 473.59 211.614 465.167 211.614Z"
            fill={color}
          />
        </svg>
      )}
      {keyuser && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 726 725"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M656.76 362.932C656.76 271.998 582.726 197.964 491.792 197.964C429.708 197.964 373.069 232.965 344.926 287.978L82.236 287.908C78.2762 287.908 74.4578 289.463 71.6294 292.292L11.5961 352.325C5.72709 358.194 5.72709 367.669 11.5961 373.538L71.6294 433.572C74.4579 436.4 78.2762 437.956 82.236 437.956L112.217 437.956C116.743 437.956 121.127 435.834 123.955 432.299L138.239 414.338L162.705 434.561C168.291 439.158 176.211 439.158 181.797 434.561L206.263 414.338L220.475 432.369C223.021 435.764 227.122 437.743 231.365 438.026C235.678 438.238 239.779 436.683 242.82 433.642L262.619 413.843L281.994 433.218C284.822 436.046 288.64 437.602 292.6 437.602L346.694 437.956C374.766 492.898 429.779 527.97 491.863 527.97C582.797 527.97 656.831 453.936 656.76 362.932ZM551.826 407.904C527.077 407.904 506.854 387.68 506.854 362.932C506.854 338.183 527.077 317.96 551.826 317.96C576.574 317.96 596.798 338.183 596.798 362.932C596.798 387.68 576.645 407.974 551.826 407.904Z"
            fill={color}
          />
        </svg>
      )}
      {supervision && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 511 511"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d)">
            <path
              d="M283.688 22H227.312C210.4 22 199.125 33.275 199.125 50.1875V444.812C199.125 461.725 210.4 473 227.312 473H283.688C300.6 473 311.875 461.725 311.875 444.812V50.1875C311.875 33.275 300.6 22 283.688 22Z"
              fill={color}
            />
          </g>
          <g filter="url(#filter1_d)">
            <path
              d="M114.562 303.875H58.1875C41.275 303.875 30 315.15 30 332.062V444.812C30 461.725 41.275 473 58.1875 473H114.562C131.475 473 142.75 461.725 142.75 444.812V332.062C142.75 315.15 131.475 303.875 114.562 303.875Z"
              fill={color}
            />
          </g>
          <g filter="url(#filter2_d)">
            <path
              d="M452.812 162.938H396.438C379.525 162.938 368.25 174.212 368.25 191.125V444.812C368.25 461.725 379.525 473 396.438 473H452.812C469.725 473 481 461.725 481 444.812V191.125C481 174.212 469.725 162.938 452.812 162.938Z"
              fill={color}
            />
          </g>
          <defs>
            <filter
              id="filter0_d"
              x="169.125"
              y="0"
              width="172.75"
              height="511"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="8" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.117647 0 0 0 0 0.529412 0 0 0 0 0.941176 0 0 0 0.2 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d"
              x="0"
              y="281.875"
              width="172.75"
              height="229.125"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="8" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.117647 0 0 0 0 0.529412 0 0 0 0 0.941176 0 0 0 0.2 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
            <filter
              id="filter2_d"
              x="338.25"
              y="140.938"
              width="172.75"
              height="370.062"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="8" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.117647 0 0 0 0 0.529412 0 0 0 0 0.941176 0 0 0 0.2 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )}
      {notification && color && red && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 520 547"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M511.308 403.134C450.402 344.26 441.196 314.628 441.196 220.547C441.196 123.728 360.056 45.2949 259.896 45.2949C159.735 45.2949 78.6967 123.826 78.6967 220.547C78.6967 271.304 77.2803 290.276 70.0971 313.454C61.0928 342.402 42.6795 370.176 8.58458 403.134C-7.70409 418.879 3.82951 445.871 26.8967 445.871H170.662L169.347 458.389C169.347 506.799 209.917 546.015 259.997 546.015C310.077 546.015 350.647 506.799 350.647 458.389L349.331 445.871H493.097C516.164 445.871 527.697 418.977 511.308 403.134ZM259.997 520.979C224.283 520.979 195.247 492.911 195.247 458.389L196.562 445.871H323.431L324.747 458.389C324.747 493.009 295.71 520.979 259.997 520.979ZM26.9979 420.835C104.698 345.727 104.698 295.655 104.698 220.547C104.698 137.615 174.304 70.3309 260.098 70.3309C345.892 70.3309 415.498 137.615 415.498 220.547C415.498 295.655 415.498 345.727 493.198 420.835H26.9979Z"
            fill={color}
          />
          <path
            d="M260.202 62.9812C278.194 62.9812 292.78 48.8824 292.78 31.4906C292.78 14.0988 278.194 0 260.202 0C242.21 0 227.625 14.0988 227.625 31.4906C227.625 48.8824 242.21 62.9812 260.202 62.9812Z"
            fill={color}
          />
          <ellipse cx="409.947" cy="163.8" rx="109.053" ry="109.2" fill={red} />
        </svg>
      )}
      {explorer && color && (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 924 891"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M617.906 560.377H659.875L923.296 815.094L844.639 891L580.69 636.792V596.547L566.172 582.538C506.256 632.208 428.391 662.264 343.135 662.264C153.619 662.264 0 514.019 0 331.132C0 148.245 153.619 0 343.135 0C532.651 0 686.269 148.245 686.269 331.132C686.269 413.406 655.123 488.547 603.389 546.368L617.906 560.377ZM106.533 325.557C106.533 448.565 209.891 548.307 337.357 548.307C464.824 548.307 568.182 448.565 568.182 325.557C568.182 202.549 464.824 102.807 337.357 102.807C209.891 102.807 106.533 202.549 106.533 325.557Z"
            fill={color}
          />
        </svg>
      )}
    </div>
  );
};

Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  notification?: boolean;
  red?: any;
  arrowLeft?: boolean;
  arrowRight?: boolean;
  dbArrowLeft?: boolean;
  dbArrowRight?: boolean;
  calandar?: boolean;
  arrow?: boolean;
  arrowWite?: boolean;
  user?: boolean;
  color?: string;
  supervision?: boolean;
  userAdd?: boolean;
  deleted?: boolean;
  explorer?: boolean;
  arrowSeek?: boolean;
  Delected?: boolean;
  delected?: boolean;
  filtre?: boolean;
  keyuser?: boolean;
  closeSmall?: boolean;
  arrowarrow?: boolean;
  arrowarrows?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/icons/component.tsx